import { BrowserFourdApi } from '.';
import { card } from '../../api/card';

export class Card implements card.Api {
  constructor(private fourd: BrowserFourdApi) {}

  selectCard(request?: card.SelectCardRequest): Promise<card.Card[]> {
    return this.fourd
      .twoWayCall<card.SelectCardRequest, card.Card[]>(
        request,
        (requestId, request) => {
          this.fourd.call4Dv2('card.selectCard', request, requestId);
        },
        (cardsResponse: card.Card[]): card.Card[] => {
          return cardsResponse.map((card) => {
            return {
              cardId: card.cardId,
              deleteCode: card.deleteCode,
              deleted: card.deleteCode !== 0,
              description: card.description,
              fullName: card.fullName,
              // Typo in property name "shortname" in LD
              shortName: card.shortName || (card as any).shortname,
              type: card.type,
            };
          });
        }
      )
      .catch(() => [] as card.Card[]);
  }

  createCard(): Promise<card.CreatedCard> {
    return this.fourd.twoWayCall<any, card.CreatedCard>(
      null,
      (requestId, request) => {
        this.fourd.call4Dv2('card.createCard', request, requestId);
      },
      (response) => {
        let responseData;
        try {
          responseData = JSON.parse(response);
        } catch (e) {
          responseData = response;
        }
        return responseData;
      }
    );
  }

  openCard(request: card.OpenCardRequest): void {
    this.fourd.call4Dv2('card.openCard', request);
  }

  //   getLists(request: BaseRequest): Promise<card.Card[]> {
  //     return this.fourd.twoWayCall<BaseRequest, card.Card[]>(
  //       request,
  //       (requestId, request) => {
  //         this.fourd.call4Dv2('card.getLists', request, requestId);
  //       },
  //       (response) => {
  //         let responseData;
  //         try {
  //           responseData = JSON.parse(response);
  //         } catch (e) {
  //           // Unable to parse response.body => response.body is not a stringify object
  //           responseData = response;
  //         }
  //         return responseData;
  //       }
  //     );
  //   }
}
